export class ComboProjeto {
	id: number;
	nome: string;
}